import React, { type FC } from 'react';

import { Stack } from '@atlaskit/primitives/compiled';

import {
	SpecificAccessDetails,
	type SpecificAccessDetailsProps,
} from './specificAccessDetails/SpecificAccessDetails.tsx';
import {
	PublicLinkDialogBody,
	type PublicLinkDialogBodyProps,
} from './publicLink/PublicLinkDialogBody.tsx';
import {
	ShareToSlackDialogBody,
	type ShareToSlackDialogBodyProps,
} from './shareToSlack/ShareToSlackDialogBody.tsx';
import {
	AccessRequestsDialogBody,
	type AccessRequestsDialogBodyProps,
} from './accessRequests/AccessRequestsDialogBody.tsx';
import {
	SpecificAccessDialogBody,
	type SpecificAccessDialogBodyProps,
} from './specificAccessDialog/SpecificAccessDialogBody.tsx';

export type BodyProps = {
	specificAccessDetails?: SpecificAccessDetailsProps;
	specificAccessDialogBody?: SpecificAccessDialogBodyProps;
	publicLinkDialogBody?: PublicLinkDialogBodyProps;
	shareToSlackDialogBody?: ShareToSlackDialogBodyProps;
	accessRequestsDialogBody?: AccessRequestsDialogBodyProps;
	// Alternative modes' bodies to go here, if we end up supporting any
};

export const Body: FC<BodyProps> = ({
	specificAccessDetails,
	specificAccessDialogBody,
	publicLinkDialogBody,
	shareToSlackDialogBody,
	accessRequestsDialogBody,
}: BodyProps) => {
	return (
		<Stack grow="fill">
			{specificAccessDetails && <SpecificAccessDetails {...specificAccessDetails} />}
			{publicLinkDialogBody && <PublicLinkDialogBody {...publicLinkDialogBody} />}
			{shareToSlackDialogBody && <ShareToSlackDialogBody {...shareToSlackDialogBody} />}
			{accessRequestsDialogBody && <AccessRequestsDialogBody {...accessRequestsDialogBody} />}
			{specificAccessDialogBody && <SpecificAccessDialogBody {...specificAccessDialogBody} />}
			{/* TODO: different bodies, if we do end up supporting different modes */}
		</Stack>
	);
};
